import { useRef as e } from "react";
import { isEqual as t } from "es-toolkit/compat";
//#region src/hooks/usePrevious.ts
var n = (n, r) => {
	let i = e({
		target: n,
		previous: n
	});
	return (r ? !r(n, i.current.target) : !t(n, i.current.target)) && (i.current.previous = i.current.target, i.current.target = n), i.current.previous;
};
//#endregion
export { n as default };

//# sourceMappingURL=usePrevious.js.map